import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import ConsultationForm from './ConsultationForm';
import { CalendarClock } from 'lucide-react';
import { Link } from 'react-router-dom';

const BookCallModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 bg-transparent border-none shadow-none">
        <DialogTitle className="sr-only">Book a Free Strategy Call</DialogTitle>
        <div>
          <ConsultationForm />
          <div className="mt-3 text-center">
            <Link
              to="/book-meeting"
              onClick={() => onOpenChange && onOpenChange(false)}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-white bg-slate-900/80 hover:bg-slate-900 rounded-full px-4 py-2 backdrop-blur"
            >
              <CalendarClock className="h-4 w-4" /> Or pick a time slot instead
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookCallModal;
